// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MinimizedCallView__container-e210af {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: 1 1 auto;
  min-width: 324px;
  max-width: 324px;
  min-height: 228px;
  max-height: 228px;
  top: 96px;
  inset-inline-end: 24px;
  background-color: var(--addition-80);
  position: absolute;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  padding: 16px 20px;
  box-sizing: border-box;
  z-index: 1;
}

.MinimizedCallView__dragging-a023b2 * {
  pointer-events: none;
}

.MinimizedCallView__offset-e60308 {
  inset-inline-end: 384px;
}

.MinimizedCallView__avatar-container-cfdb9c {
  margin-bottom: var(--indent-8px);
}

.MinimizedCallView__video-container-aa359d {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.MinimizedCallView__video-e4ad10 {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.MinimizedCallView__actions-panel-b1f260 {
  display: flex;
  align-self: end;
  z-index: 1;
  margin-inline-end: auto;
  margin-inline-start: auto;
}

.MinimizedCallView__hidable-container-c0e456 {
  display: flex;
  align-items: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 2;
}

.MinimizedCallView__hidable-container-c0e456:hover {
  opacity: 1;
}

.MinimizedCallView__chat-link-c0633f {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  user-drag: none;
  -webkit-user-drag: none;
}

.MinimizedCallView__actions-panel-container-ea91d0 {
  display: flex;
  justify-content: center;
  width: 100%;
}

.MinimizedCallView__action-panel-bd03e8 {
  padding: 16px 0 0 0;
}

.MinimizedCallView__expand-button-e86bf4 {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/MinimizedCallView/MinimizedCallView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 324px;\n  max-width: 324px;\n  min-height: 228px;\n  max-height: 228px;\n  top: 96px;\n  inset-inline-end: 24px;\n  background-color: var(--addition-80);\n  position: absolute;\n  overflow: hidden;\n  border-radius: 10px;\n  cursor: pointer;\n  padding: 16px 20px;\n  box-sizing: border-box;\n  z-index: 1;\n}\n\n.dragging * {\n  pointer-events: none;\n}\n\n.offset {\n  inset-inline-end: calc(24px + 360px);\n}\n\n.avatar-container {\n  margin-bottom: var(--indent-8px);\n}\n\n.video-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.video {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n\n.actions-panel {\n  display: flex;\n  align-self: end;\n  z-index: 1;\n  margin-inline-end: auto;\n  margin-inline-start: auto;\n}\n\n.hidable-container {\n  display: flex;\n  align-items: flex-end;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 16px;\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  z-index: 2;\n}\n\n.hidable-container:hover {\n  opacity: 1;\n}\n\n.chat-link {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  user-drag: none;\n  -webkit-user-drag: none;\n}\n\n.actions-panel-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.action-panel {\n  padding: 16px 0 0 0;\n}\n\n.expand-button {\n  position: absolute;\n  top: 8px;\n  inset-inline-end: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MinimizedCallView__container-e210af`,
	"dragging": `MinimizedCallView__dragging-a023b2`,
	"offset": `MinimizedCallView__offset-e60308`,
	"avatar-container": `MinimizedCallView__avatar-container-cfdb9c`,
	"avatarContainer": `MinimizedCallView__avatar-container-cfdb9c`,
	"video-container": `MinimizedCallView__video-container-aa359d`,
	"videoContainer": `MinimizedCallView__video-container-aa359d`,
	"video": `MinimizedCallView__video-e4ad10`,
	"actions-panel": `MinimizedCallView__actions-panel-b1f260`,
	"actionsPanel": `MinimizedCallView__actions-panel-b1f260`,
	"hidable-container": `MinimizedCallView__hidable-container-c0e456`,
	"hidableContainer": `MinimizedCallView__hidable-container-c0e456`,
	"chat-link": `MinimizedCallView__chat-link-c0633f`,
	"chatLink": `MinimizedCallView__chat-link-c0633f`,
	"actions-panel-container": `MinimizedCallView__actions-panel-container-ea91d0`,
	"actionsPanelContainer": `MinimizedCallView__actions-panel-container-ea91d0`,
	"action-panel": `MinimizedCallView__action-panel-bd03e8`,
	"actionPanel": `MinimizedCallView__action-panel-bd03e8`,
	"expand-button": `MinimizedCallView__expand-button-e86bf4`,
	"expandButton": `MinimizedCallView__expand-button-e86bf4`
};
module.exports = ___CSS_LOADER_EXPORT___;
